import { render, staticRenderFns } from "./GoodsList.vue?vue&type=template&id=23d5d3a0&"
import script from "./GoodsList.vue?vue&type=script&lang=ts&"
export * from "./GoodsList.vue?vue&type=script&lang=ts&"
import style0 from "./GoodsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports